import { get } from 'lodash';
import { FORUM_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';

export const getUserRole = user =>
  get(user, `appStore[${FORUM_APP_ID}].permissions.role`) || get(user, 'permissions.role');
